export enum FundsOriginChannelEnum {
  ALL = 'ALL',
  MANUAL = 'MANUAL',
}

export enum FundsOriginCodeEnum {
  OTHER = 'OTHER',
}
